module.exports = __webpack_public_path__ + "static/img/85076G_1_2_3_R_20200909_LC.a8f46cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/85076G_1_2_3_R_20200909_LC.png
// module id = 6csJ
// module chunks = 0